import { setDoc, doc, getFirestore } from "firebase/firestore";
import { getFunctions, httpsCallable } from 'firebase/functions';

const docUpdateTimers = new Map();
const aiTimers = {};

export const recordUpdate = (col, docId, updates, merge = true, fileDataUpdateKey) => {
	const timerKey = `${col}-${docId}`;
	const existingTimer = docUpdateTimers.get(timerKey);
	if (existingTimer) clearTimeout(existingTimer);

	docUpdateTimers.set(
		timerKey,
		setTimeout(() => {
			setDoc(doc(getFirestore(), col, docId), updates, {
				merge,
			})
				.catch((error) => {
					console.error(
						`Failed to update ${col} record ${docId}.${key}`,
						error,
					);
				})
				.finally(() => {
					if (fileDataUpdateKey) callFileDataUpdate(col, docId, fileDataUpdateKey);
					if (updates.aiResponses) {
						for (const [agent, response] of Object.entries(updates.aiResponses)) {
							if (response.completed === 'pending...') {
								callAiResponse(response.request);
							}
						}
					}
					docUpdateTimers.delete(timerKey);
				});
		}, 1000),
	);
};

export const callFileDataUpdate = async (col, docId, key) => {
	const request = {
		col,
		docId,
		key
	};

	console.log({ request });

	const functions = getFunctions();
	const createFileDataUpdateTask = httpsCallable(functions, 'createFileDataUpdateTask');

	const response = await createFileDataUpdateTask(request);
	console.log({ response });
};

export const callAiResponse = async (request) => {
	const { agent } = request;
	if (aiTimers[agent]) clearTimeout(aiTimers[agent]);
	aiTimers[agent] = setTimeout(async () => {
		console.log(`✅ calling ai response for ${agent}`);
		console.log({ request });
		const functions = getFunctions();
		const createAiResponse = httpsCallable(functions, 'createAiResponseTask');
		const response = await createAiResponse(request);
		console.log({ response });
	}, 1000);
};
